var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.serviceType==0)?_c('IntroScreen'):_vm._e(),(_vm.serviceType==1)?_c('IntroScreenOne'):_vm._e(),(_vm.serviceType==2)?_c('IntroScreenTwo'):_vm._e(),(_vm.serviceType==3)?_c('IntroScreenThree'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }